import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

import s from './NotificationAnalytics.css';
import cs from '../../commonStyle.css';
import Loader from '../../Loader';

class NotificationAnalytics extends Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getNotificationStats: PropTypes.object
    }),
    aiLogData: PropTypes.shape({
      loading: PropTypes.bool,
      getAIDecisionLog: PropTypes.object
    })
  };

  state = {
    activeSection: 'metrics'
  };

  formatHour(hour) {
    if (hour === 0) return '12am';
    if (hour === 12) return '12pm';
    if (hour < 12) return hour + 'am';
    return (hour - 12) + 'pm';
  }

  renderBarChart(hourlyStats) {
    if (!hourlyStats || hourlyStats.length === 0) {
      return (
        <div className={s.noChartData}>
          <p>Sin datos suficientes para mostrar el gráfico</p>
        </div>
      );
    }

    var maxValue = Math.max.apply(null, hourlyStats.map(function(h) { return h.totalSent || 0; }));
    if (maxValue === 0) maxValue = 1;

    var hours = [0, 3, 6, 9, 12, 15, 18, 21];
    var self = this;

    return (
      <div className={s.barChart}>
        <div className={s.barChartContainer}>
          {hours.map(function(hour) {
            var stat = hourlyStats.find(function(h) { return h.hour === hour; });
            var value = stat ? (stat.totalSent || 0) : 0;
            var heightPercent = (value / maxValue) * 100;
            var openRate = stat ? (stat.openRate || 0) : 0;

            return (
              <div key={hour} className={s.barGroup}>
                <div className={s.barWrapper}>
                  <div 
                    className={s.bar}
                    style={{ height: heightPercent + '%' }}
                    title={value + ' enviadas - ' + openRate + '% apertura'}
                  >
                    {value > 0 && <span className={s.barValue}>{value}</span>}
                  </div>
                </div>
                <span className={s.barLabel}>{self.formatHour(hour)}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    var data = this.props.data;

    if (data && data.loading) {
      return <Loader type="text" />;
    }

    var stats = data && data.getNotificationStats;

    if (!stats || stats.status !== 200) {
      return (
        <div className={s.noData}>
          <p>No hay datos de notificaciones disponibles.</p>
        </div>
      );
    }

    var self = this;

    return (
      <div className={s.analyticsContainer}>
        <Row>
          <Col lg={3} md={6} sm={6} xs={12}>
            <div className={s.kpiCard}>
              <div className={s.kpiIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
                </svg>
              </div>
              <div className={s.kpiContent}>
                <span className={s.kpiValue}>{stats.totalSent || 0}</span>
                <span className={s.kpiLabel}>Enviadas</span>
              </div>
            </div>
          </Col>
          <Col lg={3} md={6} sm={6} xs={12}>
            <div className={s.kpiCard}>
              <div className={cx(s.kpiIcon, s.kpiIconGreen)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </div>
              <div className={s.kpiContent}>
                <span className={s.kpiValue}>{stats.avgOpenRate || 0}%</span>
                <span className={s.kpiLabel}>Tasa de Apertura</span>
              </div>
            </div>
          </Col>
          <Col lg={3} md={6} sm={6} xs={12}>
            <div className={s.kpiCard}>
              <div className={cx(s.kpiIcon, s.kpiIconPurple)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                  <polyline points="10 17 15 12 10 7"/>
                  <line x1="15" y1="12" x2="3" y2="12"/>
                </svg>
              </div>
              <div className={s.kpiContent}>
                <span className={s.kpiValue}>{stats.avgClickRate || 0}%</span>
                <span className={s.kpiLabel}>Tasa de Click</span>
              </div>
            </div>
          </Col>
          <Col lg={3} md={6} sm={6} xs={12}>
            <div className={s.kpiCard}>
              <div className={cx(s.kpiIcon, s.kpiIconOrange)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div className={s.kpiContent}>
                <span className={s.kpiValue}>{self.formatHour(stats.bestHour || 9)}</span>
                <span className={s.kpiLabel}>Mejor Horario</span>
              </div>
            </div>
          </Col>
        </Row>

        <Row className={s.chartRow}>
          <Col lg={8} md={12}>
            <div className={s.chartCard}>
              <h4 className={s.chartTitle}>📊 Notificaciones por Hora (Últimos 7 días)</h4>
              <div className={s.chartWrapper}>
                {this.renderBarChart(stats.hourlyStats)}
              </div>
            </div>
          </Col>
          <Col lg={4} md={12}>
            <div className={s.chartCard}>
              <h4 className={s.chartTitle}>🎯 Rendimiento</h4>
              <div className={s.performanceStats}>
                <div className={s.perfItem}>
                  <span className={s.perfLabel}>Entregadas</span>
                  <div className={s.perfBar}>
                    <div className={s.perfFill} style={{ width: stats.totalSent > 0 ? ((stats.totalDelivered / stats.totalSent) * 100) + '%' : '0%' }} />
                  </div>
                  <span className={s.perfValue}>{stats.totalDelivered || 0}</span>
                </div>
                <div className={s.perfItem}>
                  <span className={s.perfLabel}>Leídas</span>
                  <div className={s.perfBar}>
                    <div className={cx(s.perfFill, s.perfFillGreen)} style={{ width: stats.totalSent > 0 ? ((stats.totalRead / stats.totalSent) * 100) + '%' : '0%' }} />
                  </div>
                  <span className={s.perfValue}>{stats.totalRead || 0}</span>
                </div>
                <div className={s.perfItem}>
                  <span className={s.perfLabel}>Clicks</span>
                  <div className={s.perfBar}>
                    <div className={cx(s.perfFill, s.perfFillPurple)} style={{ width: stats.totalSent > 0 ? ((stats.totalClicked / stats.totalSent) * 100) + '%' : '0%' }} />
                  </div>
                  <span className={s.perfValue}>{stats.totalClicked || 0}</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {this.renderAIDecisionLog()}
      </div>
    );
  }

  renderAIDecisionLog() {
    const { aiLogData } = this.props;
    
    if (!aiLogData || aiLogData.loading) {
      return null;
    }

    const logData = aiLogData.getAIDecisionLog || {};
    const decisions = logData.decisions || [];

    return (
      <Row className={s.chartRow}>
        <Col xs={12}>
          <div className={s.chartCard}>
            <h4 className={s.chartTitle}>🤖 AI Decision Log (Últimas decisiones)</h4>
            {decisions.length === 0 ? (
              <div className={s.noChartData}>
                <p>No hay decisiones de IA registradas aún.</p>
              </div>
            ) : (
              <div className={s.aiLogContainer}>
                {decisions.slice(0, 10).map((decision, index) => (
                  <div key={index} className={s.aiLogItem}>
                    <div className={s.aiLogHeader}>
                      <span className={cx(s.aiLogType, s['aiLogType_' + (decision.type || 'default')])}>
                        {decision.type === 'content_personalization' ? '✨ Personalización' :
                         decision.type === 'send_time' ? '⏰ Horario Óptimo' :
                         decision.type === 'lead_scoring' ? '📈 Lead Score' : '🔧 ' + decision.type}
                      </span>
                      <span className={s.aiLogTime}>
                        {moment(decision.timestamp).fromNow()}
                      </span>
                    </div>
                    <div className={s.aiLogDetails}>
                      <span className={s.aiLogUser}>Usuario #{decision.userId}</span>
                      {decision.duration && (
                        <span className={s.aiLogDuration}>{decision.duration}ms</span>
                      )}
                    </div>
                    {decision.output && (
                      <div className={s.aiLogOutput}>
                        <code>{typeof decision.output === 'string' ? decision.output : JSON.stringify(decision.output).substring(0, 100)}</code>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

const GET_NOTIFICATION_STATS = gql`
  query getNotificationStats($days: Int) {
    getNotificationStats(days: $days) {
      status
      errorMessage
      totalSent
      totalDelivered
      totalRead
      totalClicked
      avgOpenRate
      avgClickRate
      bestHour
      bestHourOpenRate
      hourlyStats {
        hour
        totalSent
        totalRead
        totalClicked
        openRate
        clickRate
      }
    }
  }
`;

const GET_AI_DECISION_LOG = gql`
  query getAIDecisionLog($limit: Int) {
    getAIDecisionLog(limit: $limit) {
      status
      totalDecisions
      decisions {
        type
        userId
        timestamp
        duration
        model
        input
        output
      }
    }
  }
`;

export default compose(
  withStyles(s, cs),
  graphql(GET_NOTIFICATION_STATS, {
    options: {
      variables: { days: 7 },
      fetchPolicy: 'network-only'
    }
  }),
  graphql(GET_AI_DECISION_LOG, {
    name: 'aiLogData',
    options: {
      variables: { limit: 20 },
      fetchPolicy: 'network-only'
    }
  })
)(NotificationAnalytics);
